<template>
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
  >
    <path d="M10 8C10 7.17157 9.32843 6.5 8.5 6.5H1.5C0.671573 6.5 0 7.17157 0 8V8.5C0 10.4714 1.85951 12.5 5 12.5C6.73125 12.5 8.07321 11.8835 8.92898 11H5V11.5C2.43216 11.5 1 9.93765 1 8.5V8C1 7.72386 1.22386 7.5 1.5 7.5H5V8H10ZM9.63934 10H5V9H9.96047C9.90673 9.34052 9.79869 9.67747 9.63934 10ZM7.75 2.75C7.75 2.57925 7.73444 2.41214 7.70466 2.25H6.67753C6.67753 2.25001 6.67753 2.24999 6.67753 2.25L5 2.25003V3.25003L7.70466 3.25C7.73444 3.08786 7.75 2.92075 7.75 2.75ZM5 0C5.96539 0 6.81459 0.497448 7.30527 1.25H5V1C4.0335 1 3.25 1.7835 3.25 2.75C3.25 3.7165 4.0335 4.5 5 4.5V4.25H7.30527C6.81459 5.00255 5.96539 5.5 5 5.5C3.48122 5.5 2.25 4.26878 2.25 2.75C2.25 1.23122 3.48122 0 5 0Z" />
  </svg>
</template>
